module.exports = __webpack_public_path__ + "img/next-button.8ccce570.svg";